import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { fetchAllTags } from "../api/tags";
import { useAuth } from "./AuthContext";

const TagsContext = createContext();

export function TagsProvider({ children }) {
  const { user } = useAuth();
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadTags = useCallback(async () => {
    setLoading(true);
    try {
      const all = await fetchAllTags();
      setTags(all || []);
    } catch (err) {
      // Silent fail
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!user) {
      setTags([]);
      setLoading(false);
      return;
    }
    loadTags();
  }, [loadTags, user]);

  return (
    <TagsContext.Provider value={{ tags, loading, reload: loadTags }}>
      {children}
    </TagsContext.Provider>
  );
}

export function useTags() {
  return useContext(TagsContext);
}
